import { createContext } from "react";

interface IGlobalContext {
  isAlertOpened: boolean;
  alertText: string;
  setIsAlertOpened: (opened: boolean) => void;
  setAlertText: (text: string) => void;
}

const defaultState = {
  isAlertOpened: false,
  alertText: "",
  setIsAlertOpened: (opened: boolean) => {},
  setAlertText: (text: string) => {},
};

const GlobalContext = createContext<IGlobalContext>(defaultState);
export default GlobalContext;
